import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M63.7019 242.758C63.7019 254.021 71.4991 262.107 82.7618 262.107C90.8478 262.107 98.3562 257.486 101.822 249.112L156.113 112.516C161.889 98.0767 163.333 92.301 163.333 85.6589C163.333 72.3748 155.247 64 140.519 64H57.3486C45.2196 64 38 71.2196 38 83.0599V105.874C38 118.292 45.7972 126.089 57.0599 126.089C68.0337 126.089 75.8309 118.292 75.8309 105.874V100.965C75.8309 99.8094 76.4085 99.2319 77.5636 99.2319H119.149V100.098L65.4346 234.095C64.2795 236.983 63.7019 239.871 63.7019 242.758Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }